import { useQuery } from "@tanstack/react-query";
import {
  gameRecordService,
  GetGameRecordsParams,
} from "../api/services/gameRecords/gameRecordsService";

const GAME_RECORDS_STALE_TIME =
  Number(process.env.REACT_APP_GAME_RECORDS_STALE_TIME) || 2 * 60 * 1000;

export const gameRecordKeys = {
  all: ["gameRecords"] as const,
  lists: () => [...gameRecordKeys.all, "list"] as const,
  list: (params: GetGameRecordsParams) =>
    [...gameRecordKeys.lists(), params] as const,
  details: () => [...gameRecordKeys.all, "detail"] as const,
  detail: (id: string) => [...gameRecordKeys.details(), id] as const,
};

export const useGameRecords = (params: GetGameRecordsParams = {}) => {
  return useQuery({
    queryKey: gameRecordKeys.list(params),
    queryFn: () => gameRecordService.getGameRecords(params),
    staleTime: GAME_RECORDS_STALE_TIME,
  });
};

export const useGameRecord = (id: string) => {
  return useQuery({
    queryKey: gameRecordKeys.detail(id),
    queryFn: () => gameRecordService.getGameRecord(id),
    enabled: !!id,
    staleTime: GAME_RECORDS_STALE_TIME,
  });
};

export const useCustomerGameRecords = (
  customerId: string,
  additionalParams: Omit<GetGameRecordsParams, "customerId"> = {},
) => {
  const params = {
    customerId,
    ...additionalParams,
  };

  return useQuery({
    queryKey: gameRecordKeys.list(params),
    queryFn: () => gameRecordService.getGameRecords(params),
    enabled: !!customerId,
    staleTime: GAME_RECORDS_STALE_TIME,
  });
};
